import { ExtraPay } from "../ExtraPay";
import { HorizontalSpacer, Layout, Panel, SaveButton } from "@mcleod/components";

export abstract class AutogenLayoutExtraPaySave extends Layout {
    buttonSave: SaveButton;
    horizontalspacer4: HorizontalSpacer;
    layoutExtraPay: ExtraPay;
    panelExtraPaySave: Panel;
}
